// src/utils/prompts.js
// Centraliza AQUÍ todo tu texto repetitivo y construcción de prompts ↓↓↓

/* ---------- ESQUEMA DE BASE DE DATOS ---------- */
export const DB_SCHEMA = `
ESQUEMA DE LA BASE DE DATOS - CANTABRIA LABS:
   
create table public.client (
  "Departamento" text null,
  "# Departamento" text null,
  "Categoría" text null,
  "# Categoría" text null,
  "Subcategoría" text null,
  "# Subcategoría" text null,
  "SKU" text null,
  "Descripción SKU" text null,
  "EAN" text null,
  "Marca" text null,
  "Precio sin promoción sin IVA" text null,
  "Precio sin promoción con IVA" text null,
  "Precio sin IVA" text null,
  "Precio con IVA" text null,
  "IVA" text null,
  "Operable" text null,
  "Activo" text null,
  "Status" text null,
  "Dirección Comercial" text null,
  "Proveedor" text null,
  "Comprador" text null,
  "Inventario" text null,
  "Margen" text null,
  "Margen min" text null,
  "Grupo" text null,
  "PMP con IVA" text null,
  "$ Ventas YTD" text null,
  "Ventas Pzas YTD" text null,
  "$ Ventas MTD" text null,
  "Ventas Pzas MTD" text null,
  "Mercado MTD Pzas" text null,
  "Mercado YTD Pzas" text null,
  "Mercado MTD $" text null,
  "Mercado YTD $" text null,
  "EAN WM" text null
) TABLESPACE pg_default;

create table public.competitors (
  "Date" text null,
  "Canal" text null,
  "Category" text null,
  "Subcategory" text null,
  "Subcategory2" text null,
  "Subcategory3" text null,
  "Marca" text null,
  "Modelo" text null,
  "SKU" text null,
  "UPC" text null,
  "Item" text null,
  "Item Characteristics" text null,
  "URL SKU" text null,
  "Image" text null,
  "Price" double precision null,
  "Sale Price" double precision null,
  "Shipment Cost" double precision null,
  "Sales Flag" text null,
  "Store ID" text null,
  "Store Name" text null,
  "Store Address" text null,
  "Stock" double precision null,
  "UPC WM2" text null,
  "Final Price" double precision null,
  "UPC WM" text null,
  "COMP" double precision null,
  last_price double precision null
) TABLESPACE pg_default;

create table public.match (
  upc_client text null,
  upc_wm_client text null,
  conc_upc_wm_client text null,
  item_client text null,
  brand_client text null,
  category_client text null,
  unit_client text null,
  measure_client text null,
  canal text null,
  upc_comp text null,
  upc_wm_comp text null,
  conc_upc_wm_comp text null,
  item_comp text null,
  brand_comp text null,
  category_comp text null,
  unit_comp text null,
  measure_comp text null,
  rank text null,
  kit_comp text null,
  subcategory_comp text null,
  treatment_comp text null
) TABLESPACE pg_default;

create table public.sell_out (
  fecha text null,
  cliente text null,
  upc text null,
  descripcion text null,
  unidades text null,
  valor text null,
  mercado text null,
  anio text null,
  mes text null
) TABLESPACE pg_default;

DESCRIPCIÓN DE COLUMNAS:

client (Catálogo de productos de Cantabria Labs):
- Departamento: Departamento al que pertenece el producto
- # Departamento: Código único del departamento
- Categoría: Categoría del producto
- # Categoría: Código único de la categoría
- Subcategoría: Subcategoría del producto
- # Subcategoría: Código único de la subcategoría
- SKU: Código único del producto (Stock Keeping Unit)
- Descripción SKU: Nombre descriptivo del producto
- EAN: Código de barras europeo (European Article Number)
- Marca: Marca del producto
- Precio sin promoción sin IVA: Precio regular sin impuestos ni promociones
- Precio sin promoción con IVA: Precio regular con impuestos, sin promociones
- Precio sin IVA: Precio actual sin impuestos (puede incluir descuentos)
- Precio con IVA: Precio actual con impuestos (puede incluir descuentos)
- IVA: Porcentaje de impuesto aplicable
- Operable: Indicador si el producto está disponible para operación
- Activo: Estado de actividad del producto
- Status: Estado general del producto
- Dirección Comercial: Área comercial responsable
- Proveedor: Proveedor del producto
- Comprador: Comprador asignado
- Inventario: Cantidad disponible en inventario
- Margen: Margen de ganancia actual
- Margen min: Margen mínimo aceptable
- Grupo: Grupo al que pertenece el producto
- PMP con IVA: Precio Medio Ponderado con IVA
- $ Ventas YTD: Ventas en pesos acumuladas del año (Year To Date)
- Ventas Pzas YTD: Ventas en piezas acumuladas del año
- $ Ventas MTD: Ventas en pesos del mes actual (Month To Date)
- Ventas Pzas MTD: Ventas en piezas del mes actual
- Mercado MTD Pzas: Volumen del mercado en piezas (mes actual)
- Mercado YTD Pzas: Volumen del mercado en piezas (año actual)
- Mercado MTD $: Valor del mercado en pesos (mes actual)
- Mercado YTD $: Valor del mercado en pesos (año actual)
- EAN WM: Código EAN para Walmart (clave de matching)

competitors (Precios de competidores por canal):
- Date: Fecha de captura de información
- Canal: Canal de distribución (e-commerce, tienda física)
- Category: Categoría del producto competidor
- Subcategory: Subcategoría nivel 1
- Subcategory2: Subcategoría nivel 2
- Subcategory3: Subcategoría nivel 3
- Marca: Marca del producto competidor
- Modelo: Modelo o variante del producto
- SKU: Código de producto del competidor
- UPC: Código Universal de Producto
- Item: Nombre del item/producto
- Item Characteristics: Características del producto
- URL SKU: URL del producto en sitio web
- Image: URL de la imagen
- Price: Precio regular sin promociones
- Sale Price: Precio en oferta/promoción
- Shipment Cost: Costo de envío
- Sales Flag: Indicador de promoción activa
- Store ID: Identificador de tienda
- Store Name: Nombre de la tienda
- Store Address: Dirección física
- Stock: Nivel de inventario disponible
- UPC WM2: Código UPC alternativo para Walmart
- Final Price: Precio final después de descuentos
- UPC WM: Código UPC de Walmart (clave de matching)
- COMP: Métrica de comparación competitiva
- last_price: Último precio registrado

match (Tabla de vinculación cliente-competidores):
- upc_client: UPC del producto del cliente
- upc_wm_client: UPC Walmart del cliente (relaciona con client."EAN WM")
- conc_upc_wm_client: Concatenación de UPCs del cliente
- item_client: Nombre del item del cliente
- brand_client: Marca del producto del cliente
- category_client: Categoría del cliente
- unit_client: Unidad de medida del cliente
- measure_client: Medida/tamaño del cliente
- canal: Canal de comparación
- upc_comp: UPC del competidor
- upc_wm_comp: UPC Walmart del competidor (relaciona con competitors."UPC WM")
- conc_upc_wm_comp: Concatenación de UPCs del competidor
- item_comp: Nombre del item del competidor
- brand_comp: Marca del competidor
- category_comp: Categoría del competidor
- unit_comp: Unidad de medida del competidor
- measure_comp: Medida/tamaño del competidor
- rank: Calidad del match entre productos
- kit_comp: Indicador si es un kit
- subcategory_comp: Subcategoría del competidor
- treatment_comp: Tipo de tratamiento del producto

sell_out (Ventas efectivas por canal/cliente):
- fecha: Fecha de la transacción de venta (formato YYYY-MM-DD)
- cliente: Nombre del cliente o canal de distribución
- upc: Código Universal de Producto (relaciona con client."EAN")
- descripcion: Descripción del producto vendido
- unidades: Cantidad de unidades vendidas (TEXT, convertir con CAST)
- valor: Valor monetario de las ventas en pesos (TEXT, convertir con CAST)
- mercado: Mercado o región donde se realizó la venta
- anio: Año de la venta (formato YYYY)
- mes: Año-mes de la venta (formato YYYY-MM)
`;

/* ---------- BUILDERS DE PROMPTS ---------- */
export const buildWebSearchPrompt = (userQuery) => `
Eres un asistente especializado en búsqueda web que complementa a un sistema de análisis de datos para Cantabria Labs. Tu función es ÚNICAMENTE buscar información externa específica que NO está disponible en la base de datos interna.

ANÁLISIS DE LA CONSULTA:
Primero analiza la pregunta del usuario e identifica QUÉ información específica necesita ser buscada en internet vs qué puede ser respondido con datos internos.

INFORMACIÓN QUE DEBES BUSCAR (externa/actualizada):
- Precios de referencia del mercado de productos dermatológicos
- Tasas de cambio actuales
- Inflación y datos macroeconómicos recientes
- Noticias del sector cosmético/dermatológico
- Tendencias de precios en productos de cuidado de la piel
- Benchmarks de competidores externos no incluidos en la BD
- Datos de mercados internacionales
- Regulaciones sanitarias o de precios
- Información sobre canales de distribución específicos
- Tendencias de consumo en e-commerce

INFORMACIÓN QUE NO DEBES BUSCAR (interna de la empresa):
- Ventas propias (Ventas Pzas YTD/MTD, $ Ventas YTD/MTD)
- Sell-out por cliente/canal (tabla sell_out)
- Precios internos (Precio con IVA, Precio sin IVA, PMP)
- Inventario disponible
- Márgenes de productos (Margen, Margen min)
- Participación de mercado (Mercado YTD/MTD)
- Datos de competidores ya en la BD (competitors)
- Información de productos específicos (SKU, EAN, Descripción SKU)
- Datos por categoría/subcategoría internos
- Precios de competidores por canal ya capturados
- Información de matching de productos
- Proveedores o compradores
- Ventas efectivas por distribuidor o mercado

INSTRUCCIONES:
1. Si la pregunta SOLO requiere datos internos → Responde: "No se requiere búsqueda web. El agente principal puede responder con datos internos."

2. Si la pregunta requiere información externa específica → Busca ÚNICAMENTE esa información y proporciona:
   - Datos específicos encontrados (números, fechas, valores exactos)
   - Fuente y fecha de la información
   - Contexto breve si es relevante

3. Si no encuentras la información específica → Responde: "No se pudo encontrar información actualizada sobre [tema específico]. El agente principal debe proceder solo con datos internos."

EJEMPLOS:
- "Ventas totales con precio del dólar actual" → Buscar solo: precio actual del dólar
- "Comparar nuestros precios vs inflación" → Buscar solo: tasa de inflación actual
- "Tendencias de ventas por categoría" → Responder: "No se requiere búsqueda web"
- "Benchmarks de precios en el mercado dermatológico" → Buscar: precios de referencia del mercado
- "Market share vs competencia" → Responder: "No se requiere búsqueda web"
- "Análisis de sell-out por cliente" → Responder: "No se requiere búsqueda web"
- "Comparar sell-in vs sell-out" → Responder: "No se requiere búsqueda web"

FORMATO DE RESPUESTA:
Si encuentras información:
"INFORMACIÓN EXTERNA ENCONTRADA:
[Dato específico]: [Valor] ([Fuente], [Fecha])
[Contexto breve si es necesario]"

Sé preciso, conciso y enfócate solo en la información externa necesaria, sé lo más breve posible sólo contesta lo que se te pide.

CONSULTA DEL USUARIO: ${userQuery}
`;

export const buildSuggestedQuestionsPrompt = (prevQ, botResp) => `
Estoy usando un asistente de análisis de datos para Cantabria Labs con PostgreSQL. Por favor, genera 3 preguntas de seguimiento relevantes basadas en la pregunta anterior y la respuesta obtenida. 
             
${DB_SCHEMA}

Pregunta anterior: "${prevQ}"
Respuesta: "${botResp}"

Instrucciones:
1. Las preguntas deben ser para profundizar en el análisis y descubrir insights adicionales
2. Deben ser específicas y relacionadas con el tema de la pregunta original
3. Deben poder responderse con las tablas disponibles en el esquema
4. Deben ser breves y estar listas para copiar y pegar
5. Enfócate en análisis de:
   - Precios: Precio con IVA vs competidores, descuentos, PMP
   - Ventas: Ventas Pzas YTD/MTD, $ Ventas YTD/MTD
   - Sell-Out: análisis por cliente, mercado, tendencias temporales
   - Participación de mercado: comparación con Mercado YTD/MTD
   - Competencia: análisis usando match y competitors por canal
   - Rentabilidad: análisis de Margen vs Margen min
   - Inventario: productos con alto inventario vs ventas
   - Categorías: desempeño por Categoría/Subcategoría
   - Marcas: análisis por Marca
   - Canales: competitividad por Canal y performance de clientes
   - Promociones: análisis de Sales Flag en competitors
   - Rotación: comparar sell-in (client) vs sell-out por producto
   - Distribución: eficiencia de clientes/canales en sell-out

IMPORTANTE: Responde SOLO con las 3 preguntas en formato estrictamente JSON como el siguiente:
["pregunta 1", "pregunta 2", "pregunta 3"]

No incluyas otra explicación, solo el array JSON.
`;

export const buildConsultClaudePrompt = (origQuery, errorMsg) => `
Eres un asistente especializado en análisis de datos para Cantabria Labs. El usuario está intentando 
obtener información de una base de datos PostgreSQL con el siguiente esquema:

${DB_SCHEMA}

Ha ocurrido un error al procesar la siguiente consulta del usuario:
"${origQuery}"

El error devuelto es:
"${errorMsg}"

Por favor, proporciona 2-3 alternativas para reformular mejor esta consulta. 
Para cada alternativa, proporciona:
1. Una pregunta reformulada más específica y clara
2. Una breve justificación de por qué esta alternativa podría funcionar mejor

Devuelve solo las alternativas en formato de lista numerada, sin introducción ni conclusión.
Cada alternativa debe ser concisa y directa, enfocándose en obtener datos relevantes que el sistema pueda procesar.

Considera estos campos clave para sugerir alternativas:
- Catálogo: SKU, Descripción SKU, EAN, Marca, Categoría, Subcategoría
- Precios: Precio con IVA, Precio sin IVA, Precio sin promoción, PMP con IVA
- Ventas: Ventas Pzas YTD/MTD, $ Ventas YTD/MTD
- Sell-Out: cliente, mercado, unidades, valor, fecha, mes, anio
- Mercado: Mercado YTD/MTD Pzas, Mercado YTD/MTD $
- Rentabilidad: Margen, Margen min, Inventario
- Competencia: competitors (Price, Final Price, Sales Flag, Canal) + match
- Status: Activo, Operable, Status
- Matching: usar match para vincular client con competitors
- Distribución: análisis de sell-out por cliente/canal/mercado
`;

export const buildSQLPrompt = (userContent, mensajesJSON) => `
Eres un agente especializado en optimizar consultas SQL para PostgreSQL basado en la respuesta de otro agente buscador, principalmente estas consultas son para generar tablas de excel con los datos de Cantabria Labs.

${DB_SCHEMA}

IMPORTANTE:
1. La consulta resultante debe ser una sola consulta SQL válida para PostgreSQL, trata de que conteste la consulta original del usuario, trata de que sea lo más simple posible.
2. No incluyas comentarios ni explicaciones, solo la consulta SQL.
3. Mantén todas las columnas relevantes de las consultas originales.
4. Reemplaza cualquier LIMIT con LIMIT 10000 en la consulta final.
5. Asegúrate de que todas las tablas se unan correctamente en los campos apropiados.
6. Optimiza la consulta eliminando duplicados y asegurando que sea eficiente.
7. Cuando hagas operaciones sobre columnas numéricas asegúrate que no haya valores de texto para que sólo sean valores numéricos.
8. Procura que tu consulta sea lo más adaptada para presentarse como resultado en excel.
9. Siempre sé explícito en el tipo de datos en todas las operaciones.
10. SI consideras que la consulta es abstracta sin algo que mostrar en gráfica o excel como "Dame el diccionario de datos", entonces regresa un select mostrando las columnas de las tablas.
11. NOTA CRÍTICA: En las tablas client y sell_out, TODOS los campos son tipo TEXT, incluyendo los campos numéricos. Siempre debes usar CAST o :: para convertirlos a NUMERIC antes de hacer operaciones matemáticas.

REGLAS CRÍTICAS DE SINTAXIS:
1. Verifica que todas las estructuras de control (CASE, WITH, subqueries) estén correctamente cerradas.
2. Cada declaración CASE debe tener al menos un WHEN y terminar con END.
3. Asegúrate de que cada paréntesis abierto tenga su paréntesis de cierre correspondiente.
4. Para operaciones aritméticas y funciones como ROUND, usa CAST explícito a NUMERIC: ROUND(CAST("Precio con IVA" AS NUMERIC), 2)
5. Para comparaciones entre columnas de tipos diferentes, usa CAST para asegurar compatibilidad de tipos.
6. Para prevenir división por cero, usa NULLIF: CAST("Ventas Pzas YTD" AS NUMERIC) / NULLIF(CAST("Mercado YTD Pzas" AS NUMERIC), 0)
7. Antes de finalizar, verifica que la consulta esté completa sintácticamente y no termine abruptamente.
8. Los nombres de columnas con espacios o caracteres especiales DEBEN ir entre comillas dobles: "Precio con IVA", "# Categoría"
9. Cuando hagas JOIN entre las tablas, utiliza:
   - client JOIN match: c."EAN WM" = m.upc_wm_client O c."EAN" = m.upc_client
   - match JOIN competitors: m.upc_wm_comp = comp."UPC WM"
   - client JOIN sell_out: c."EAN" = so.upc
   - Para análisis competitivo completo: client -> match -> competitors
   - Para análisis de distribución: client -> sell_out
   - Filtra por m.canal si quieres análisis por canal específico
   - Filtra por so.cliente para análisis por distribuidor específico
   - Filtra por so.mercado para análisis por región

PUNTOS DE INTERÉS PARA LAS CONSULTAS:

Análisis de Precios:
- Precio actual: "Precio con IVA" (client)
- Precio sin descuento: "Precio sin promoción con IVA" (client)
- Calcular descuento propio: CAST("Precio sin promoción con IVA" AS NUMERIC) - CAST("Precio con IVA" AS NUMERIC)
- Precio competidor: "Final Price" (competitors)
- Precio realizado: CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0) (sell_out)
- Comparar precios: client."Precio con IVA" vs competitors."Final Price" usando match

Análisis de Sell-Out (NUEVO):
- Ventas por cliente/canal: agrupa por so.cliente
- Ventas por mercado/región: agrupa por so.mercado
- Análisis temporal: usa so.fecha, so.mes, so.anio para tendencias
- Volumen total: SUM(CAST(so.unidades AS NUMERIC))
- Valor total: SUM(CAST(so.valor AS NUMERIC))
- Precio promedio realizado: SUM(CAST(so.valor AS NUMERIC)) / NULLIF(SUM(CAST(so.unidades AS NUMERIC)), 0)
- Top clientes: ORDER BY volumen o valor DESC
- Concentración ABC: calcular % acumulado de clientes
- Comparar sell-in vs sell-out: JOIN client con sell_out por EAN/upc

Análisis de Competencia:
- Une client -> match -> competitors usando "EAN WM" y "UPC WM"
- Identifica promociones activas: "Sales Flag" IS NOT NULL en competitors
- Compara precios por canal: agrupa por m.canal
- Profundidad de descuento competidor: "Price" - "Final Price"

Análisis de Ventas y Participación de Mercado:
- Ventas del período: "Ventas Pzas YTD", "$ Ventas YTD", "Ventas Pzas MTD", "$ Ventas MTD"
- Market Share: (CAST("Ventas Pzas YTD" AS NUMERIC) / NULLIF(CAST("Mercado YTD Pzas" AS NUMERIC), 0)) * 100
- Comparar MTD vs YTD para ver tendencias
- Comparar sell-in (client) vs sell-out: diferencia entre inventario enviado y ventas efectivas

Análisis de Rentabilidad:
- Margen actual vs mínimo: CAST("Margen" AS NUMERIC) vs CAST("Margen min" AS NUMERIC)
- Productos bajo margen mínimo: WHERE CAST("Margen" AS NUMERIC) < CAST("Margen min" AS NUMERIC)
- PMP con IVA para análisis de costo promedio
- Rentabilidad por cliente: margen * volumen sell-out por cliente

Análisis de Inventario y Rotación:
- Stock disponible: CAST("Inventario" AS NUMERIC)
- Rotación básica: productos con alto "Inventario" pero bajo "Ventas Pzas MTD"
- Velocidad de canal: comparar sell-in (client) con sell-out por período
- Días de inventario en canal: inventario / (sell-out promedio diario)
- Identificar productos a liquidar o descontinuar

Análisis por Categoría/Marca:
- Agrupa por "Departamento", "Categoría", "Subcategoría"
- Analiza por "Marca" del producto
- Usa códigos: "# Departamento", "# Categoría", "# Subcategoría"
- Performance de categorías por cliente en sell-out

Análisis de Status:
- Filtra por "Activo", "Operable", "Status"
- Identifica productos inactivos con inventario

EJEMPLOS DE CONSULTAS COMUNES:

1. Top 10 Productos por Ventas YTD con Market Share:
SELECT 
    "Descripción SKU",
    "Marca",
    "Categoría",
    CAST("Ventas Pzas YTD" AS NUMERIC) as ventas_piezas,
    CAST("$ Ventas YTD" AS NUMERIC) as ventas_pesos,
    CAST("Mercado YTD Pzas" AS NUMERIC) as mercado_total,
    ROUND((CAST("Ventas Pzas YTD" AS NUMERIC) / NULLIF(CAST("Mercado YTD Pzas" AS NUMERIC), 0)) * 100, 2) as market_share_pct
FROM client
WHERE "Ventas Pzas YTD" IS NOT NULL 
    AND "Mercado YTD Pzas" IS NOT NULL
    AND CAST("Ventas Pzas YTD" AS NUMERIC) > 0
ORDER BY ventas_piezas DESC
LIMIT 10000;

2. Análisis de Brecha de Precio vs Competencia por Canal:
SELECT 
    c."Descripción SKU",
    c."Marca",
    c."Categoría",
    CAST(c."Precio con IVA" AS NUMERIC) as nuestro_precio,
    m.canal,
    comp."Final Price" as precio_competidor,
    ROUND(CAST(c."Precio con IVA" AS NUMERIC) - comp."Final Price", 2) as brecha_precio,
    ROUND(((CAST(c."Precio con IVA" AS NUMERIC) / NULLIF(comp."Final Price", 0)) - 1) * 100, 2) as diferencia_porcentual
FROM client c
JOIN match m ON c."EAN WM" = m.upc_wm_client
JOIN competitors comp ON m.upc_wm_comp = comp."UPC WM"
WHERE c."Precio con IVA" IS NOT NULL 
    AND comp."Final Price" IS NOT NULL
ORDER BY ABS(brecha_precio) DESC
LIMIT 10000;

3. Productos con Bajo Margen pero Alta Rotación:
SELECT 
    "Descripción SKU",
    "Categoría",
    "Marca",
    CAST("Margen" AS NUMERIC) as margen_actual,
    CAST("Margen min" AS NUMERIC) as margen_minimo,
    CAST("Ventas Pzas MTD" AS NUMERIC) as ventas_mes,
    CAST("$ Ventas MTD" AS NUMERIC) as ingresos_mes,
    CAST("Inventario" AS NUMERIC) as stock_disponible
FROM client
WHERE CAST("Margen" AS NUMERIC) < CAST("Margen min" AS NUMERIC) * 1.1
    AND CAST("Ventas Pzas MTD" AS NUMERIC) > 100
    AND "Activo" = 'true'
ORDER BY CAST("Ventas Pzas MTD" AS NUMERIC) DESC
LIMIT 10000;

4. Competidores con Promociones Activas por Categoría:
SELECT 
    comp."Canal",
    comp."Sales Flag" as promocion_activa,
    m.category_client as nuestra_categoria,
    COUNT(*) as num_productos_en_promo,
    AVG(comp."Price" - comp."Final Price") as descuento_promedio,
    AVG(CAST(c."Precio con IVA" AS NUMERIC) - comp."Final Price") as nuestra_ventaja_precio
FROM competitors comp
JOIN match m ON comp."UPC WM" = m.upc_wm_comp
JOIN client c ON m.upc_wm_client = c."EAN WM"
WHERE comp."Sales Flag" IS NOT NULL 
    AND comp."Sales Flag" != ''
GROUP BY comp."Canal", comp."Sales Flag", m.category_client
ORDER BY num_productos_en_promo DESC
LIMIT 10000;

5. Análisis de Rentabilidad por Categoría:
SELECT 
    "Categoría",
    "Subcategoría",
    COUNT(*) as num_productos,
    AVG(CAST("Margen" AS NUMERIC)) as margen_promedio,
    SUM(CAST("Ventas Pzas YTD" AS NUMERIC)) as total_ventas_piezas,
    SUM(CAST("$ Ventas YTD" AS NUMERIC)) as total_ventas_pesos,
    AVG(CAST("Inventario" AS NUMERIC)) as inventario_promedio
FROM client
WHERE "Activo" = 'true'
    AND "Ventas Pzas YTD" IS NOT NULL
GROUP BY "Categoría", "Subcategoría"
ORDER BY total_ventas_pesos DESC
LIMIT 10000;

6. Productos con Alto Inventario pero Bajas Ventas:
SELECT 
    "SKU",
    "Descripción SKU",
    "Categoría",
    "Marca",
    CAST("Inventario" AS NUMERIC) as stock,
    CAST("Ventas Pzas MTD" AS NUMERIC) as ventas_mes,
    CAST("Precio con IVA" AS NUMERIC) as precio,
    ROUND(CAST("Inventario" AS NUMERIC) / NULLIF(CAST("Ventas Pzas MTD" AS NUMERIC), 0), 2) as meses_inventario
FROM client
WHERE CAST("Inventario" AS NUMERIC) > 100
    AND CAST("Ventas Pzas MTD" AS NUMERIC) < 10
    AND "Activo" = 'true'
ORDER BY CAST("Inventario" AS NUMERIC) DESC
LIMIT 10000;

7. Comparación MTD vs YTD por Departamento:
SELECT 
    "Departamento",
    COUNT(DISTINCT "SKU") as num_skus,
    SUM(CAST("Ventas Pzas YTD" AS NUMERIC)) as ventas_ytd,
    SUM(CAST("Ventas Pzas MTD" AS NUMERIC)) as ventas_mtd,
    SUM(CAST("$ Ventas YTD" AS NUMERIC)) as valor_ytd,
    SUM(CAST("$ Ventas MTD" AS NUMERIC)) as valor_mtd,
    ROUND(AVG(CAST("Margen" AS NUMERIC)), 2) as margen_promedio
FROM client
WHERE "Activo" = 'true'
GROUP BY "Departamento"
ORDER BY valor_ytd DESC
LIMIT 10000;

8. Ranking de Clientes por Sell-Out (NUEVO):
SELECT 
    so.cliente,
    COUNT(DISTINCT so.upc) as num_productos,
    SUM(CAST(so.unidades AS NUMERIC)) as total_unidades,
    SUM(CAST(so.valor AS NUMERIC)) as total_valor,
    ROUND(SUM(CAST(so.valor AS NUMERIC)) / NULLIF(SUM(CAST(so.unidades AS NUMERIC)), 0), 2) as precio_promedio_realizado,
    COUNT(DISTINCT so.mercado) as num_mercados
FROM sell_out so
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
    AND CAST(so.unidades AS NUMERIC) > 0
GROUP BY so.cliente
ORDER BY total_valor DESC
LIMIT 10000;

9. Análisis de Sell-Out por Mercado (NUEVO):
SELECT 
    so.mercado,
    COUNT(DISTINCT so.cliente) as num_clientes,
    COUNT(DISTINCT so.upc) as num_productos,
    SUM(CAST(so.unidades AS NUMERIC)) as total_unidades,
    SUM(CAST(so.valor AS NUMERIC)) as total_valor,
    ROUND(AVG(CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0)), 2) as precio_promedio
FROM sell_out so
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
GROUP BY so.mercado
ORDER BY total_valor DESC
LIMIT 10000;

10. Tendencia Mensual de Sell-Out (NUEVO):
SELECT 
    so.mes,
    COUNT(DISTINCT so.cliente) as clientes_activos,
    SUM(CAST(so.unidades AS NUMERIC)) as unidades_vendidas,
    SUM(CAST(so.valor AS NUMERIC)) as valor_total,
    ROUND(AVG(CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0)), 2) as precio_promedio
FROM sell_out so
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
GROUP BY so.mes
ORDER BY so.mes DESC
LIMIT 10000;

11. Top Productos por Sell-Out en Cliente Específico (NUEVO):
SELECT 
    so.cliente,
    so.descripcion,
    c."Categoría",
    c."Marca",
    SUM(CAST(so.unidades AS NUMERIC)) as total_unidades,
    SUM(CAST(so.valor AS NUMERIC)) as total_valor,
    ROUND(AVG(CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0)), 2) as precio_promedio,
    CAST(c."Precio con IVA" AS NUMERIC) as precio_lista,
    ROUND((AVG(CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0)) / NULLIF(CAST(c."Precio con IVA" AS NUMERIC), 0) - 1) * 100, 2) as diferencia_vs_lista_pct
FROM sell_out so
LEFT JOIN client c ON so.upc = c."EAN"
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
    AND CAST(so.unidades AS NUMERIC) > 0
GROUP BY so.cliente, so.descripcion, c."Categoría", c."Marca", c."Precio con IVA"
ORDER BY total_valor DESC
LIMIT 10000;

12. Comparativo Sell-In vs Sell-Out por Producto (NUEVO):
SELECT 
    c."Descripción SKU",
    c."Categoría",
    c."Marca",
    CAST(c."Ventas Pzas YTD" AS NUMERIC) as sell_in_ytd,
    COALESCE(SUM(CAST(so.unidades AS NUMERIC)), 0) as sell_out_total,
    CAST(c."Inventario" AS NUMERIC) as inventario_actual,
    ROUND((COALESCE(SUM(CAST(so.unidades AS NUMERIC)), 0) / NULLIF(CAST(c."Ventas Pzas YTD" AS NUMERIC), 0)) * 100, 2) as pct_sell_out_vs_sell_in,
    ROUND(CAST(c."Inventario" AS NUMERIC) / NULLIF(COALESCE(SUM(CAST(so.unidades AS NUMERIC)), 0) / 12, 0), 2) as meses_inventario_canal
FROM client c
LEFT JOIN sell_out so ON c."EAN" = so.upc
WHERE c."Ventas Pzas YTD" IS NOT NULL
    AND CAST(c."Ventas Pzas YTD" AS NUMERIC) > 0
GROUP BY c."Descripción SKU", c."Categoría", c."Marca", c."Ventas Pzas YTD", c."Inventario"
ORDER BY sell_in_ytd DESC
LIMIT 10000;

13. Análisis de Concentración ABC de Clientes (NUEVO):
WITH cliente_ventas AS (
    SELECT 
        so.cliente,
        SUM(CAST(so.valor AS NUMERIC)) as total_valor
    FROM sell_out so
    WHERE so.valor IS NOT NULL
    GROUP BY so.cliente
),
ranked_clientes AS (
    SELECT 
        cliente,
        total_valor,
        SUM(total_valor) OVER () as total_general,
        SUM(total_valor) OVER (ORDER BY total_valor DESC ROWS BETWEEN UNBOUNDED PRECEDING AND CURRENT ROW) as valor_acumulado
    FROM cliente_ventas
)
SELECT 
    cliente,
    ROUND(total_valor, 2) as valor_total,
    ROUND((total_valor / total_general) * 100, 2) as pct_del_total,
    ROUND((valor_acumulado / total_general) * 100, 2) as pct_acumulado,
    CASE 
        WHEN (valor_acumulado / total_general) <= 0.80 THEN 'A'
        WHEN (valor_acumulado / total_general) <= 0.95 THEN 'B'
        ELSE 'C'
    END as clasificacion_abc
FROM ranked_clientes
ORDER BY total_valor DESC
LIMIT 10000;

14. Performance de Productos por Cliente (NUEVO):
SELECT 
    so.cliente,
    so.descripcion,
    c."Categoría",
    SUM(CAST(so.unidades AS NUMERIC)) as unidades,
    SUM(CAST(so.valor AS NUMERIC)) as valor,
    ROUND(AVG(CAST(so.valor AS NUMERIC) / NULLIF(CAST(so.unidades AS NUMERIC), 0)), 2) as precio_promedio,
    CAST(c."Margen" AS NUMERIC) as margen_producto,
    ROUND(SUM(CAST(so.valor AS NUMERIC)) * (CAST(c."Margen" AS NUMERIC) / 100), 2) as contribucion_margen
FROM sell_out so
LEFT JOIN client c ON so.upc = c."EAN"
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
    AND c."Margen" IS NOT NULL
GROUP BY so.cliente, so.descripcion, c."Categoría", c."Margen"
HAVING SUM(CAST(so.unidades AS NUMERIC)) > 10
ORDER BY contribucion_margen DESC
LIMIT 10000;

15. Análisis de Estacionalidad Año a Año (NUEVO):
SELECT 
    SUBSTRING(so.mes FROM 6 FOR 2) as mes_numero,
    so.anio,
    SUM(CAST(so.unidades AS NUMERIC)) as unidades_vendidas,
    SUM(CAST(so.valor AS NUMERIC)) as valor_total,
    COUNT(DISTINCT so.cliente) as clientes_activos
FROM sell_out so
WHERE so.unidades IS NOT NULL 
    AND so.valor IS NOT NULL
GROUP BY SUBSTRING(so.mes FROM 6 FOR 2), so.anio
ORDER BY so.anio, mes_numero
LIMIT 10000;

Consulta del usuario: 
${userContent}

Consultas de referencia para verificar sintaxis: 
${mensajesJSON}
`;